import { ca } from '@cian/analytics';

import { TTrackingParamsType } from '../../types/page/trackingParamsType';

interface ITrackShareButtonClickProps extends TTrackingParamsType {
  label: 'TellStartPage' | 'TellEndPage';
}

export const trackShareButtonClickClick = ({ label, dealType, cianSource, siteType }: ITrackShareButtonClickProps) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'RentContract',
    action: 'Click',
    label,
    page: {
      pageType: 'OnlineRentContract',
      siteType,
      extra: {
        dealType,
        cian_source: cianSource,
      },
    },
  });
};
